import React, { Component } from "react";

import { Radio } from "antd";

export default class Step2 extends Component {
  render() {
    return (
      <div className="col-md-8 mr-auto ml-auto mb-3">
        <h4>What are you working on?</h4>
        <p>In 300 words or less</p>

        <textarea max="300" rows="10"
          className="form-control"
          onChange={e => this.props.change("description", e.target.value)}
        ></textarea>
      </div>
    );
  }
}
